import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, withKeys as _withKeys, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "pi-folder-open pi text-cyan-700" }, null, -1)
const _hoisted_2 = { class: "text-right" }
const _hoisted_3 = { class: "text-right" }

import {inject, onMounted, ref} from 'vue'
import {AxiosStatic} from "axios";
import DataTable, {DataTableFilterEvent, DataTablePageEvent} from 'primevue/datatable';
import InputText from 'primevue/inputtext'
import Column from 'primevue/column';
import moment from "moment";

// Define injects

export default /*#__PURE__*/_defineComponent({
  __name: 'ListInvoicesTable',
  setup(__props, { expose }) {


const axios = inject<AxiosStatic>('axios')

// Define properties
const items = ref<any[]>([])
const loading = ref<boolean>(true)
const dt = ref(null);
const pageIndex = ref<number>(0)
const pageSize = ref<number>(25)
const totalRecords = ref<number>(0)
const filters = ref({
  number: {value: '', matchMode: 'contains'},
  issuer: {value: '', matchMode: 'contains'},
  recipient: {value: '', matchMode: 'contains'},

})

// Define lifecycle hooks
onMounted(() => {
  loadData()
})

// Define methods
function calculateTotalPrice(items: any[], field: string): number {
  return items.reduce((curr, acc) => acc[field] + curr, 0).toFixed(2)
}

function reloadTable() {
  loadData(mapFilterToDataTablePayload(filters.value))
}

function loadData(filterData: any = {}) {
  loading.value = true
  axios?.post("/datatable/invoices?sort=vatPaymentDate&page=" + pageIndex.value + "&pageSize=" + pageSize.value, filterData)
      .then((response) => {
        if (response.status === 200) {
          items.value = response.data.rows
        }
        totalRecords.value = response.data.paginator.totalRecords
        loading.value = false
      }).catch(error => {
    console.error('Can not load timeline', error)
    loading.value = false
  })
}

function getDay(row: any): string {
  return moment(row.fromTime).format("dddd")
}

function getTime(dateValue: string): string {
  return moment(dateValue).format("HH:mm")
}

function getDate(dateValue: string): string {
  return moment(dateValue).format("DD.MM.YYYY")
}

function onPage(event: DataTablePageEvent) {
  pageIndex.value = event.page
  loadData()
}

function onFilter(event: DataTableFilterEvent) {
  loadData(mapFilterToDataTablePayload(filters.value))
}

function mapFilterToDataTablePayload(vueFilter: any): any {
  const filter: any = {}
  const keys = Object.keys(vueFilter)

  for (let a = 0; a < keys.length; a++) {
    const key = keys[a]
    const {value: _value, matchMode} = vueFilter[keys[a]]
    if (_value != null && _value.length > 0) {

      switch (key) {
        case 'issuer':
          filter['issuerCompany'] = {
            type: getFilterType(matchMode),
            value: '%' + _value + '%',
            childKey: "companyName"
          }
          break
        case 'recipient':
          filter['recipientCompany'] = {
            type: getFilterType(matchMode),
            value: '%' + _value + '%',
            childKey: "companyName"
          }
          break;
        default:
          filter[key] = {
            type: getFilterType(matchMode),
            value: '%' + _value + '%'
          }
      }
    }
  }
  return filter
}

function getFilterType(vueType: string): string {
  switch (vueType.toUpperCase()) {
    case 'CONTAINS':
      return 'like'
    default:
      return '='
  }
}

// Define exposes
expose({reloadTable})



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_unref(DataTable), {
    rowHover: true,
    page: pageIndex.value+1,
    ref_key: "dt",
    ref: dt,
    dataKey: "id",
    value: items.value,
    lazy: true,
    paginator: true,
    rows: pageSize.value,
    totalRecords: totalRecords.value,
    filterDisplay: "row",
    filters: filters.value,
    "onUpdate:filters": _cache[0] || (_cache[0] = ($event: any) => ((filters).value = $event)),
    onPage: _cache[1] || (_cache[1] = ($event: any) => (onPage($event))),
    onFilter: _cache[2] || (_cache[2] = ($event: any) => (onFilter($event))),
    loading: loading.value
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Column), { header: "#" }, {
        body: _withCtx(({data}) => [
          _createVNode(_component_router_link, {
            to: '/private/invoices/'+data.id
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 2
          }, 1032, ["to"])
        ]),
        _: 1
      }),
      _createVNode(_unref(Column), {
        header: "NUMBER",
        field: "number"
      }, {
        filter: _withCtx(({filterModel,filterCallback}) => [
          _createVNode(_unref(InputText), {
            type: "text",
            modelValue: filterModel.value,
            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
            onKeydown: _withKeys(($event: any) => (filterCallback()), ["enter"]),
            class: "p-column-filter p-inputtext-sm",
            placeholder: "Search by number"
          }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeydown"])
        ]),
        _: 1
      }),
      _createVNode(_unref(Column), {
        header: "ISSUE DATE",
        field: "issueDate"
      }, {
        body: _withCtx(({data}) => [
          _createTextVNode(_toDisplayString(getDate(data.issueDate)), 1)
        ]),
        _: 1
      }),
      _createVNode(_unref(Column), {
        header: "PAYMENT DATE",
        field: "paymentDate"
      }, {
        body: _withCtx(({data}) => [
          _createTextVNode(_toDisplayString(getDate(data.paymentDate)), 1)
        ]),
        _: 1
      }),
      _createVNode(_unref(Column), {
        header: "ISSUER",
        field: "issuer"
      }, {
        body: _withCtx(({data}) => [
          _createTextVNode(_toDisplayString(data.issuerCompany.companyName), 1)
        ]),
        filter: _withCtx(({filterModel,filterCallback}) => [
          _createVNode(_unref(InputText), {
            type: "text",
            modelValue: filterModel.value,
            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
            onKeydown: _withKeys(($event: any) => (filterCallback()), ["enter"]),
            class: "p-column-filter p-inputtext-sm",
            placeholder: "Search by issuer"
          }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeydown"])
        ]),
        _: 1
      }),
      _createVNode(_unref(Column), {
        header: "RECIPIENT",
        field: "recipient"
      }, {
        body: _withCtx(({data}) => [
          _createTextVNode(_toDisplayString(data.recipientCompany.companyName), 1)
        ]),
        filter: _withCtx(({filterModel,filterCallback}) => [
          _createVNode(_unref(InputText), {
            type: "text",
            modelValue: filterModel.value,
            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
            onKeydown: _withKeys(($event: any) => (filterCallback()), ["enter"]),
            class: "p-column-filter p-inputtext-sm",
            placeholder: "Search by recipient"
          }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeydown"])
        ]),
        _: 1
      }),
      _createVNode(_unref(Column), { header: "PRICE" }, {
        body: _withCtx(({data}) => [
          _createElementVNode("div", _hoisted_2, _toDisplayString(calculateTotalPrice(data.items, 'price')), 1)
        ]),
        _: 1
      }),
      _createVNode(_unref(Column), { header: "VAT PRICE" }, {
        body: _withCtx(({data}) => [
          _createElementVNode("div", _hoisted_3, _toDisplayString(calculateTotalPrice(data.items,'totalPrice')), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["page", "value", "rows", "totalRecords", "filters", "loading"]))
}
}

})